module.exports = __webpack_public_path__ + "static/media/logo.5c74ce70.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = 225
// module chunks = 0